import React, {
  FunctionComponent,
  useEffect,
  useRef,
  useState,
} from "react";
import styles from "./ContactDetails.module.css";
import { IoIosAddCircleOutline } from "react-icons/io";
import { BiPencil } from "react-icons/bi";
import ContactButton from "../../Components/Button/ContactButton";
import { useLocation } from "react-router";
import {
  changeLeadStage,
  fetchContactResources,
  fetchLeadTasks,
  toggleis_button_called,
} from "../../Services/contacts";
import {
  getDateAndTime,
  properFormat,
} from "../../Values/utils";
import {
  HiVideoCamera,
  HiOutlinePhotograph,
  HiOutlineMicrophone,
  HiPhone,
} from "react-icons/hi";
import { ImFileText2 } from "react-icons/im";
import InterestedLeadModal from "../../Components/Modals/InterestedLeadModal/InterestedLeadModal";
import NotInterestedLeadModal from "../../Components/Modals/NotInterestedModal/NotInterestedModal";
import CallBackModal from "../../Components/Modals/CallBackModal/CallBackModal";
import LostModal from "../../Components/Modals/LostModal/LostModal";
import CreateModal from "../../Components/Modals/CreateModal/CreateModal";
import NotesModal from "../../Components/Modals/NotesModal/NotesModal";
import { connect, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import RescheduleModal from "../../Components/Modals/RescheduleModal/RescheduleModal";
import ImportModal from "../../Components/Modals/ImportModal/ImportContactsModal";
import ProfileImageModal from "../../Components/Modals/ProfileImageModal/ProfileImageModal";
import AttachmentModal from "../../Components/Modals/AttachmentModal/AttachmentModal";
import Loading from "../../Components/Loading/Loading";
import OwnerModal from "../../Components/Modals/ChangeOwnerModal/ChangeOwnerModal";
import axios from "axios";
import { fetchCustomButtons } from "../../Services/organizations";
import { showSnackbarAction } from "../../Redux/actions";
import { themeColors } from "../../Components/theme";
import { url } from "../../Values/constants";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Grid, Paper, useMediaQuery, useTheme } from "@mui/material";
import "../../theme-vars.css";

type props = {
  user: any;
  organizationUsers: any;
  theme: any;
  authToken: any;
  contactHeader: any;
};

let usersList: any[] = [];
const ContactDetails: FunctionComponent<props> = ({
  user,
  organizationUsers,
  theme,
  authToken,
  contactHeader,
}) => {
  const location: any = useLocation();
  if (location.state == undefined) {
    // window.location.href = "https://login1.read-pro.com/";
    console.log("Extra work remaining...");
  }
  const [tasksList, setTasksList] = useState<
    any[] | undefined
  >(undefined);
  const [notesList, setNotesList] = useState<
    any[] | undefined
  >(undefined);
  const [attachmentsList, setAttachmentsList] = useState<
    any[] | undefined
  >(undefined);
  const [load, setLoad] = useState(false);

  // to open the custom button dropdwon if there are more than 2 custom buttoms
  const [open, setOpen] = useState(false);
  const drop = useRef(null);

  // top css property for dropdown custom button
  const top = 30;
  // margin top css property for dropdown custom button
  const topMargin = 5;

  const [callLogsList, setCallLogsList] = useState<
    any[] | undefined
  >(undefined);
  const [customButtons, setCustomButtons] = useState<
    any[] | undefined
  >(undefined);
  const [title, setTitle] = useState("");
  const [interestedModal, setInterestedModal] =
    useState(false);
  const [callbackModal, setCallbackModal] = useState(false);
  const [notInterestedModal, setNotInterestedModal] =
    useState(false);
  const [lostModal, setLostModal] = useState(false);
  const [createModal, setCreateModal] = useState(false);
  const [rescheduleModal, setRescheduleModal] =
    useState(false);
  const [noteModal, setNoteModal] = useState(false);
  const [picModal, setPicModal] = useState(false);
  const [vidModal, setVidModal] = useState(false);
  const [fileModal, setFileModal] = useState(false);
  const [ownerButton, setOwnerButton] = useState(false);
  const [freshFilterValue, setFreshFilterValue] = useState<any>();
  const [bookingIdData, setBookingIdData] = useState<any>();
  const themeMUI = useTheme();
  const isMobile = useMediaQuery(themeMUI.breakpoints.down("sm"));


  useEffect(() => {
    handleBookingContactId();
  }, []);
  const createUsersList = (
    email: string,
    users: any[],
    uid: boolean
  ) => {
    users.map((item: any) => {
      if (usersList.includes(item)) {
        return;
      } else {
        if (
          item.reporting_to === email &&
          item.status === "ACTIVE"
        ) {
          if (!usersList.includes(item)) {
            usersList.push(item);
          }

          createUsersList(item.user_email, users, uid);
        }
      }
    });
  };

  useEffect(() => {
    const subuser = fetchLeadTasks(
      (data) => setTasksList(data),
      location.state.detail.contactId
    );
    const subcontacts = fetchContactResources(
      (data) => setNotesList(data),
      (data) => setAttachmentsList(data),
      (data) => setCallLogsList(data),
      location.state.detail.contactId
    );
    const subToggleButtons = fetchCustomButtons(
      user.organization_id,
      (data) => setCustomButtons(data)
    );
    sessionStorage.setItem("org", user.organization_id)
    // localStorage.setItem("currentPage",location.state?.Currentpage);
    return () => {
      subuser();
      subcontacts();
      subToggleButtons();
    };
  }, [location.state, user]);
  const dispatcher = useDispatch();
  const history = useHistory();

  // useEffect(()=>{

  // },[])
  // console.log("locationstate",location.state)
  const callCustomButton = async (
    url: string,
    parameters: any,
    headers: any,
    type: string
  ) => {


    const isObjectEmpty = (object: any) => {
      var isEmpty = true;
      for (let keys in object) {
        isEmpty = false;
        break; // exiting since we found that the object is not empty
      }
      return isEmpty;
    };

    let res;
    if (type.toLowerCase() === "post") {
      for (let key in parameters) {
        let wildcard = parameters[key].split("$");
        if (wildcard.length > 1) {
          parameters[key] =
            location.state.detail[wildcard[1]];
        }
      }

      if (!isObjectEmpty(headers)) {
        const config = {
          headers: headers,
        };
        res = await axios.post(url, parameters, config);
      } else {
        res = await axios.post(url, parameters);
      }
      dispatcher(
        showSnackbarAction(
          "Custom Button Action Successful",
          "success"
        )
      );
    } else if (type.toLowerCase() === "get") {
      res = await axios.get(url);
    }

    toggleis_button_called(location.state.detail.contactId);
  };

 const handleBookingContactId = async () => {
  try {
    const bodyData = {
      contactId: location.state?.detail?.contactId,
      uid: location.state?.detail?.uid,
    };

    axios.defaults.headers.common['x-access-token'] = authToken;

    const getBookingRes = await axios.post(
      `${url}/bookings/contactId`,
      bodyData
    );

    if (getBookingRes?.data) {
      setBookingIdData(getBookingRes.data);
    }
  } catch (error: any) {
    // Axios error handling
    if (error.response) {
      console.error(
        'API Error:',
        error.response.status,
        error.response.data
      );
      // optional: show toast or alert
      // toast.error(error.response.data.message || 'Something went wrong');
    } else if (error.request) {
      console.error('No response from server:', error.request);
    } else {
      console.error('Unexpected error:', error.message);
    }
  }
};


  const handleBooking = async () => {
    const bodyData = {
      organization_id: location.state.detail.organization_id,
      uid: location.state.detail.uid,
      contact_no: location.state.detail.contact_no,
    }
    axios.defaults.headers.common['x-access-token'] =
      authToken

    const getBookingContactNORes = await axios.post(
      url + '/bookings/details',
      bodyData
    );
    if (getBookingContactNORes.data) {
      history.push({
        pathname: '/addBooking',
        state: { "booking_type": "REBOOKING", "reBookingData": bodyData }
      })
    }
    else {
      history.push({
        pathname: '/addBooking',
        state: { "Contact_details": location.state.detail, "notesList": notesList, "callLogsList": callLogsList, "attachmentsList": attachmentsList }
      })
    }
  }

  const containerStyles = { backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
  const cardContainerStyles = { backgroundColor: theme ? themeColors.cardBackgroundColor : themeColors.cardBackgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
  const tdStyles = {
    backgroundColor: theme ? themeColors.tdBackgroundColor : themeColors.tdBackgroundColorDark,
    color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
  }

  const fontStyleLarge = {
    fontFamily: "var(--font-family-main)",
    fontSize: "var(--font-size-large)"
  };

  const fontStylesMedium = {
    fontFamily: "var(--font-family-main)",
    fontSize: "var(--font-size-medium)"
  };

  const fontStylesSmall = {
    fontFamily: "var(--font-family-main)",
    fontSize: "var(--font-size-small)"
  };
  return (
    <Box
      sx={{
        marginTop: isMobile ? "7%" : "5%",
        px: isMobile ? 1 : 2,
        width: "100vw",
        minWidth: isMobile ? "0" : "900px",
        bgcolor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark,
        color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
        overflowX: "hidden"
      }}
    >
      <Grid container spacing={isMobile ? 1 : 2} sx={{ width: "100%", flexWrap: isMobile ? "wrap" : "nowrap" }}>
        <Grid item xs={12} md={9}>
          <Paper
            elevation={2}
            sx={{
              p: isMobile ? 1 : 2,
              borderRadius: 2,
              mb: 2,
              bgcolor: theme ? themeColors.cardBackgroundColor : themeColors.cardBackgroundColorDark,
              minHeight: "calc(100vh - 90px)",
            }}
          >
            <Box display="flex" alignItems="center" gap={2} mb={2}>
              <button
                className={styles.addBoxBlk}
                onClick={history.goBack}
                style={{ minWidth: 40, minHeight: 20 }}
              >
                <ArrowBackIcon />
              </button>
              <Box>
                <h6 style={{ margin: 0, ...fontStylesMedium }}>
                  Name : {location.state.detail.customer_name
                    .toLowerCase()
                    .split(" ")
                    .map((word: any) => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(" ")}
                </h6>
                <p style={{ margin: 0, ...fontStylesSmall }}>{location.state.detail.email}</p>
              </Box>
            </Box>
            <Grid container spacing={isMobile ? 1 : 2} sx={{ height: "calc(50vh - 150px)", minHeight: isMobile ? "auto" : "250px", overflowY: "auto" }}>
              <Grid item xs={12} md={6}>
                <Box
                  display="flex"
                  flexDirection="row"
                  gap={1}
                  alignItems="center"
                  mb={2}
                >
                  <Box className={styles.buttonContainer} sx={{ flexDirection: "row", gap: 1 }}>
                    {properFormat(
                      location.state.detail.stage
                    ) === "Fresh" ? (
                      <>
                        <ContactButton backgroundColor="#29ab87" color="#fff" title="Interested" clicked={() => setInterestedModal(true)} />
                        <ContactButton backgroundColor="#f7d560" color="#fff" title="Call Back" clicked={() => setCallbackModal(true)} />
                        <ContactButton backgroundColor="#ff6961" color="#fff" title="Not-Interested" clicked={() => setNotInterestedModal(true)} />
                      </>
                    ) : properFormat(
                      location.state.detail.stage
                    ) === "Call Back" ? (
                      <>
                        <ContactButton backgroundColor="#29ab87" color="#fff" title="Interested" clicked={() => setInterestedModal(true)} />
                        <ContactButton backgroundColor="#f7d560" color="#fff" title="Re-Callback" clicked={() => setCallbackModal(true)} />
                        <ContactButton backgroundColor="#ff6961" color="#fff" title="Not-Interested" clicked={() => setNotInterestedModal(true)} />
                      </>
                    ) : properFormat(
                      location.state.detail.stage
                    ) === "Interested" ? (
                      <>
                        <ContactButton backgroundColor="#29ab87" color="#fff" title="Won" clicked={() => {
                          changeLeadStage(
                            location.state.detail.contactId,
                            { stage: "WON" },
                            () => { },
                            dispatcher,
                            () => { },
                            history,
                            tasksList
                          );
                          history.push({
                            pathname: '/addBooking',
                            state: { "Contact_details": location.state.detail, "notesList": notesList, "callLogsList": callLogsList, "attachmentsList": attachmentsList }
                          })
                        }} />
                        <ContactButton backgroundColor="#e34234" color="#fff" title="Lost" clicked={() => setLostModal(true)} />
                        <ContactButton backgroundColor="#f7d560" color="#fff" title="Re Schedule" clicked={() => setRescheduleModal(true)} />
                        <ContactButton backgroundColor="#272944" color="#fff" title="Create" clicked={() => setCreateModal(true)} />
                      </>
                    ) : properFormat(
                      location.state.detail.stage
                    ) === "Won" ? (
                      <>
                        {bookingIdData && bookingIdData?.length === 0 && (
                          <>
                            <ContactButton backgroundColor="#e34234" color="#fff" title="Lost" clicked={() => setLostModal(true)} />
                            <ContactButton backgroundColor="#f7d560" color="#fff" title="Re Schedule" clicked={() => setRescheduleModal(true)} />
                            <ContactButton backgroundColor="#272944" color="#fff" title="Create" clicked={() => setCreateModal(true)} />
                          </>
                        )}
                      </>
                    ) : (<></>)}
                  </Box>
                </Box>
                <Box>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                    <Box sx={{ minWidth: 120, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {contactHeader.find((obj: any) => obj.label === "email").value} :
                    </Box>
                    <Box sx={{ ml: 1, fontWeight: "bold", color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {location.state.detail.email}
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                    <Box sx={{ minWidth: 120, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {contactHeader.find((obj: any) => obj.label === "contact_no").value} :
                    </Box>
                    <Box sx={{ ml: 1, fontWeight: "bold", color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {location.state.detail.contact_no}
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                    <Box sx={{ minWidth: 120, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {contactHeader.find((obj: any) => obj.label === "alternate_no").value} :
                    </Box>
                    <Box sx={{ ml: 1, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {location.state.detail.alternate_no}
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                    <Box sx={{ minWidth: 120, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {contactHeader.find((obj: any) => obj.label === "location").value} :
                    </Box>
                    <Box sx={{ ml: 1, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {location.state.detail.location}
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                    <Box sx={{ minWidth: 120, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {contactHeader.find((obj: any) => obj.label === "property_type").value} :
                    </Box>
                    <Box sx={{ ml: 1, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {location.state.detail.property_type}
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                    <Box sx={{ minWidth: 120, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {contactHeader.find((obj: any) => obj.label === "property_stage").value} :
                    </Box>
                    <Box sx={{ ml: 1, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {location.state.detail.property_stage}
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                    <Box sx={{ minWidth: 120, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {contactHeader.find((obj: any) => obj.label === "budget").value} :
                    </Box>
                    <Box sx={{ ml: 1, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {location.state.detail.budget}
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                    <Box sx={{ minWidth: 120, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {contactHeader.find((obj: any) => obj.label === "project").value} :
                    </Box>
                    <Box sx={{ ml: 1, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {location.state.detail.project}
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                    <Box sx={{ minWidth: 120, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {contactHeader.find((obj: any) => obj.label === "not_int_reason").value} :
                    </Box>
                    <Box sx={{ ml: 1, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {location.state.detail.not_int_reason}
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                    <Box sx={{ minWidth: 120, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {contactHeader.find((obj: any) => obj.label === "lost_reason").value} :
                    </Box>
                    <Box sx={{ ml: 1, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {location.state.detail.lost_reason}
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                    <Box sx={{ minWidth: 120, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {contactHeader.find((obj: any) => obj.label === "other_lost_reason").value} :
                    </Box>
                    <Box sx={{ ml: 1, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {location.state.detail.other_not_init_reason}
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                    <Box sx={{ minWidth: 120, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {contactHeader.find((obj: any) => obj.label === "addset").value} :
                    </Box>
                    <Box sx={{ ml: 1, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {location.state.detail.addset}
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                    <Box sx={{ minWidth: 120, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {contactHeader.find((obj: any) => obj.label === "stage_change_at").value} :
                    </Box>
                    <Box sx={{ ml: 1, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {location.state.detail.stage_change_at !== ""
                        ? getDateAndTime(
                          location.state.detail
                            .stage_change_at,
                          "LLL"
                        )
                        : ""}
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                    <Box sx={{ minWidth: 120, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {contactHeader.find((obj: any) => obj.label === "field_four").value} :
                    </Box>
                    <Box sx={{ ml: 1, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {location.state.detail.field_four}
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                    <Box sx={{ minWidth: 120, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {contactHeader.find((obj: any) => obj.label === "field_five").value} :
                    </Box>
                    <Box sx={{ ml: 1, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {location.state.detail.field_five}
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                    <Box sx={{ minWidth: 120, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {contactHeader.find((obj: any) => obj.label === "field_six").value} :
                    </Box>
                    <Box sx={{ ml: 1, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {location.state.detail.field_six}
                    </Box>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box>

                  <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                    <Box sx={{ minWidth: 120, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {contactHeader.find((obj: any) => obj.label === "next_follow_up_type").value} :
                    </Box>
                    <Box sx={{ ml: 1, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {location.state.detail.next_follow_up_type}
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                    <Box sx={{ minWidth: 120, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {contactHeader.find((obj: any) => obj.label === "next_follow_up_date_time").value} :
                    </Box>
                    <Box sx={{ ml: 1, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {location.state.detail.next_follow_up_date_time !== ""
                        ? getDateAndTime(location.state.detail.next_follow_up_date_time, "LLL")
                        : ""}
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                    <Box sx={{ minWidth: 120, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {contactHeader.find((obj: any) => obj.label === "lead_source").value} :
                    </Box>
                    <Box sx={{ ml: 1, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {location.state.detail.lead_source}
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                    <Box sx={{ minWidth: 120, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      Reporting To :
                    </Box>
                    <Box sx={{ ml: 1, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {location.state.detail.reporting_to}
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                    <Box sx={{ minWidth: 120, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {contactHeader.find((obj: any) => obj.label === "property_sub_type").value} :
                    </Box>
                    <Box sx={{ ml: 1, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {location.state.detail.property_sub_type}
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                    <Box sx={{ minWidth: 120, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {contactHeader.find((obj: any) => obj.label === "call_back_reason").value} :
                    </Box>
                    <Box sx={{ ml: 1, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {location.state.detail.call_back_reason}
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                    <Box sx={{ minWidth: 120, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {contactHeader.find((obj: any) => obj.label === "other_lost_reason").value} :
                    </Box>
                    <Box sx={{ ml: 1, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {location.state.detail.other_lost_reason}
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                    <Box sx={{ minWidth: 120, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {contactHeader.find((obj: any) => obj.label === "created_by").value} :
                    </Box>
                    <Box sx={{ ml: 1, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {location.state.detail.created_by}
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                    <Box sx={{ minWidth: 120, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {contactHeader.find((obj: any) => obj.label === "created_at").value} :
                    </Box>
                    <Box sx={{ ml: 1, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {getDateAndTime(location.state.detail.created_at, "LLL")}
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                    <Box sx={{ minWidth: 120, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {contactHeader.find((obj: any) => obj.label === "lead_assign_time").value} :
                    </Box>
                    <Box sx={{ ml: 1, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {getDateAndTime(location.state.detail.lead_assign_time, "LLL")}
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                    <Box sx={{ minWidth: 120, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {contactHeader.find((obj: any) => obj.label === "campaign").value} :
                    </Box>
                    <Box sx={{ ml: 1, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {location.state.detail.campaign}
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                    <Box sx={{ minWidth: 120, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {contactHeader.find((obj: any) => obj.label === "modified_at").value} :
                    </Box>
                    <Box sx={{ ml: 1, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {location.state.detail.modified_at !== ""
                        ? getDateAndTime(location.state.detail.modified_at, "LLL")
                        : ""}
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                    <Box sx={{ minWidth: 120, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {contactHeader.find((obj: any) => obj.label === "field_one").value} :
                    </Box>
                    <Box sx={{ ml: 1, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {location.state.detail.field_one}
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                    <Box sx={{ minWidth: 120, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {contactHeader.find((obj: any) => obj.label === "field_two").value} :
                    </Box>
                    <Box sx={{ ml: 1, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {location.state.detail.field_two}
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                    <Box sx={{ minWidth: 120, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {contactHeader.find((obj: any) => obj.label === "field_three").value} :
                    </Box>
                    <Box sx={{ ml: 1, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, ...fontStylesSmall }}>
                      {location.state.detail.field_three}
                    </Box>
                  </Box>
                </Box>
              </Grid>
            </Grid>
            <Paper elevation={1} sx={{ p: 2, borderRadius: 2, mt: 2, height: "calc(50vh - 125px)", minHeight: isMobile ? "auto" : "170px", overflowY: "auto" }}>
              {/* <h6 style={{ fontWeight: 600, marginBottom: 8, ...fontStylesMedium }}>Tasks</h6> */}
              <Box sx={{ overflowX: "auto" }}>
                <table className={styles.table} >
                  <thead className={styles.head}>
                    <tr>
                      <th className={styles.th}>Tasks</th>
                      <th className={styles.th}>Date</th>
                      <th className={styles.th}>Time</th>
                      <th className={styles.th}>Status Type</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tasksList?.map((item: any, index: number) => (
                      <tr key={index} style={tdStyles}>
                        <td className={styles.td} style={tdStyles}>{item.type}</td>
                        <td className={styles.td} style={tdStyles}>
                          {item.due_date.toDate ? getDateAndTime(item.due_date.toDate(), "DD MMM YY") : ""}
                        </td>
                        <td className={styles.td} style={tdStyles}>
                          {item.due_date.toDate ? getDateAndTime(item.due_date.toDate(), "LT") : ""}
                        </td>
                        <td className={styles.td} style={tdStyles}>{item.status}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Box>
            </Paper>
          </Paper>
        </Grid>
        <Grid item xs={12} md={3}>
          <Box sx={{ width: "100%" }}>
            <Box
              sx={{ gap: 2, bgcolor: theme ? "#fff" : "#222", borderRadius: 2, height: "calc(100vh - 90px)", minHeight: "calc(100vh - 90px)", boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)" }}
            >
              {/* Notes Section */}
              <Paper elevation={1} sx={{ p: 2, borderRadius: 2, mb: 2, height: "calc(40vh - 85px)", minHeight: "calc(40vh - 85px)" }}>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                  <h6 style={fontStylesSmall}>Notes</h6>
                  <IoIosAddCircleOutline color="#272944" cursor="pointer" size="20" onClick={() => setNoteModal(true)} />
                </Box>
                <Box className={styles.container}>
                  {notesList?.map((item: any, index: number) => (
                    <Box key={index} className={styles.noteDisplay}>
                      <Box className={styles.box}>
                        <Box className={styles.innerBox}>
                          <Box className={styles.dateAndCreatedByBox}>
                            <p className={styles.date}>
                              {getDateAndTime(item.created_at.toDate(), "LLL")}
                            </p>
                            <p className={styles.createdBy}>{item.userEmail}</p>
                          </Box>
                          <p className={styles.note} style={fontStylesSmall}>{item.note}</p>
                        </Box>
                      </Box>
                    </Box>
                  ))}
                  {notesList?.length === 0 && (
                    <p style={{ textAlign: "center" }}>No Notes</p>
                  )}
                </Box>
              </Paper>
              {/* Attachments Section */}
              <Paper elevation={1} sx={{ p: 2, borderRadius: 2, mb: 2, height: "calc(40vh - 85px)", minHeight: "calc(40vh - 85px)" }}>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                  <h6 style={fontStylesSmall}>Attachments</h6>
                  <Box className={styles.attachmentItems}>
                    <Box sx={{ px: 1 }}>
                      <HiVideoCamera size={15} color="#272944" cursor="pointer" onClick={() => { setVidModal(true); setTitle("Upload Video"); }} />
                    </Box>
                    <Box sx={{ px: 1 }}>
                      <HiOutlinePhotograph size={15} color="#272944" cursor="pointer" onClick={() => { setPicModal(true); setTitle("Upload Image"); }} />
                    </Box>
                    <Box sx={{ px: 1 }}>
                      <ImFileText2 size={15} color="#272944" cursor="pointer" onClick={() => { setFileModal(true); setTitle("Upload Files"); }} />
                    </Box>
                  </Box>
                </Box>
                <Box className={styles.attachmentContainer}>
                  {load && <Loading />}
                  {attachmentsList?.map((item: any, index: number) => (
                    <Box key={index} className={styles.attachmentBox}>
                      {item.type === "video" && <HiVideoCamera size={15} color="#272944" />}
                      {item.type === "photo" && <HiOutlinePhotograph size={15} color="#272944" />}
                      {item.type === "audio" && <HiOutlineMicrophone size={15} color="#272944" />}
                      {item.type === "file" && <ImFileText2 size={15} color="#272944" />}
                      <p className={styles.note}><a href={item.url}>{item.name}</a></p>
                    </Box>
                  ))}
                  {attachmentsList?.length === 0 && (
                    <p style={{ textAlign: "center" }}>No Attachments</p>
                  )}
                </Box>
              </Paper>
              {/* Call Logs Section */}
              <Paper elevation={1} sx={{ p: 2, borderRadius: 2, height: "calc(40vh - 85px)", minHeight: "calc(40vh - 85px)" }}>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                  <h6 style={fontStylesSmall}>Call Logs</h6>
                  <IoIosAddCircleOutline cursor="pointer" color="#272944" size="20" />
                </Box>
                <Box className={styles.attachmentContainer}>
                  {callLogsList?.map((item: any, index: number) => (
                    <Box key={index} className={styles.attachmentBox}>
                      <HiPhone size={50} color="#272944" />
                      <p className={styles.note} >
                        {getDateAndTime(item.created_at.toDate(), "LLL")}
                      </p>
                      <p className={styles.note} style={{ marginLeft: "auto" }}>{item.callTime}</p>
                    </Box>
                  ))}
                  {callLogsList?.length === 0 && (
                    <p style={{ textAlign: "center" }}>No Call Logs</p>
                  )}
                </Box>
              </Paper>
            </Box>
          </Box>
        </Grid>
      </Grid>
      {ownerButton && (
        <OwnerModal
          open={ownerButton}
          close={() => {
            setOwnerButton(false);
            history.push("/");
          }}
          usersList={usersList}
          rowsSelected={[location.state.detail]}
          organization_id={user.organization_id}
          freshFilterValue={freshFilterValue}
        />
      )}

      {picModal && (
        <AttachmentModal
          open={picModal}
          close={() => setPicModal(false)}
          title={title}
          type={"photo"}
          contactDetail={location.state.detail}
          attachmentsList={
            attachmentsList ? attachmentsList : []
          }
        />
      )}
      {vidModal && (
        <AttachmentModal
          open={vidModal}
          close={() => setVidModal(false)}
          title={title}
          type={"video"}
          contactDetail={location.state.detail}
          attachmentsList={
            attachmentsList ? attachmentsList : []
          }
        />
      )}
      {fileModal && (
        <AttachmentModal
          open={fileModal}
          close={() => setFileModal(false)}
          title={title}
          type={"file"}
          contactDetail={location.state.detail}
          attachmentsList={
            attachmentsList ? attachmentsList : []
          }
        />
      )}
      {interestedModal === true && (
        <InterestedLeadModal
          contactDetail={location.state.detail}
          close={() => setInterestedModal(false)}
          open={interestedModal}
          notes={notesList ? notesList : []}
          tasksData={tasksList ? tasksList : []}
        />
      )}
      {notInterestedModal === true && (
        <NotInterestedLeadModal
          contactDetail={location.state.detail}
          close={() => setNotInterestedModal(false)}
          open={notInterestedModal}
          tasksData={tasksList ? tasksList : []}
          notes={notesList ? notesList : []}
        />
      )}
      {callbackModal === true && (
        <CallBackModal
          contactDetail={location.state.detail}
          close={() => setCallbackModal(false)}
          open={callbackModal}
          tasksData={tasksList ? tasksList : []}
          notes={notesList ? notesList : []}
        />
      )}
      {lostModal === true && (
        <LostModal
          contactDetail={location.state.detail}
          close={() => setLostModal(false)}
          open={lostModal}
          tasksData={tasksList ? tasksList : []}
          notes={notesList ? notesList : []}
        />
      )}
      {createModal === true && (
        <CreateModal
          contactDetail={location.state.detail}
          close={() => setCreateModal(false)}
          open={createModal}
          tasksData={tasksList ? tasksList : []}
          notes={notesList ? notesList : []}
        />
      )}
      {rescheduleModal === true && (
        <RescheduleModal
          contactDetail={location.state.detail}
          close={() => setRescheduleModal(false)}
          open={rescheduleModal}
          tasksData={tasksList ? tasksList : []}
          notes={notesList ? notesList : []}
        />
      )}
      {noteModal === true && (
        <NotesModal
          notes={notesList ? notesList : []}
          contactDetail={location.state.detail}
          close={() => setNoteModal(false)}
          open={noteModal}
          userEmail={user.user_email}
        />
      )}
    </Box>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    role: state.user.role,
    contacts: state.contacts,
    organizationUsers: state.organizationUsers.data,
    teamLeadUsers: state.teamLeadUsers.data,
    theme: state.theme.isLightMode,
    authToken: state.user.authToken,
    contactHeader: state.contactHeaderList.data,
  };
};

export default connect(mapStateToProps)(ContactDetails);